import { render, staticRenderFns } from "./quick_match_add_new.vue?vue&type=template&id=2f6d5cc8&scoped=true&"
import script from "./quick_match_add_new.vue?vue&type=script&lang=js&"
export * from "./quick_match_add_new.vue?vue&type=script&lang=js&"
import style0 from "./quick_match_add_new.vue?vue&type=style&index=0&id=2f6d5cc8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6d5cc8",
  null
  
)

export default component.exports